import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "dark", setTheme: () => {}, accent: "gold", setAccent: () => {} });
const STORAGE_KEY = "stb_theme";
const ACCENT_KEY = "stb_accent";

export const ACCENTS = [
  { id: "gold",    label: "Champagne Gold", hex: "#E5C158" },
  { id: "emerald", label: "Emerald",         hex: "#10B981" },
  { id: "sapphire",label: "Sapphire Blue",   hex: "#3B82F6" },
  { id: "rose",    label: "Rose Copper",     hex: "#F472B6" },
];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem(STORAGE_KEY) || "dark";
  });
  const [accent, setAccent] = useState(() => {
    if (typeof window === "undefined") return "gold";
    return localStorage.getItem(ACCENT_KEY) || "gold";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("accent-gold", "accent-emerald", "accent-sapphire", "accent-rose");
    root.classList.add(`accent-${accent}`);
    localStorage.setItem(ACCENT_KEY, accent);
  }, [accent]);

  return (
    <ThemeContext.Provider value={{
      theme, setTheme, toggle: () => setTheme(t => t === "dark" ? "light" : "dark"),
      accent, setAccent,
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
